let $hyoo_sync_revision = "827fd0d"